export default __webpack_public_path__ + "static/media/AIG.68f78c45.png";